var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9,
    r: 9,
    fill: "#B8EF36"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.466 5.182c-.48 0-.874-.155-1.184-.464-.31-.31-.464-.697-.464-1.16 0-.465.155-.852.464-1.161.31-.325.704-.488 1.184-.488.464 0 .85.163 1.16.488.31.31.465.696.465 1.16 0 .464-.155.851-.465 1.16-.31.31-.696.465-1.16.465zM11.09 14.182V8.455a1.636 1.636 0 10-3.272 0v5.727a1.636 1.636 0 003.273 0z",
    fill: "#000"
  })));
}
export default SvgPreviewInfo;